module.exports = __webpack_public_path__ + "img/sand-rock-big-16.9cc8a4a6.png";